import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BatchInfo } from '../models/batch-info';
import { JsonHttpService } from '../../shared/http/json-http.service';

@Injectable({
    providedIn: 'root'
})
export class BatchingService {

    constructor(private httpService: JsonHttpService) { }

    public getBatchInfoForDocument(documentId: number): Promise<BatchInfo> {
        const options = { params: new HttpParams().set('documentId', `${documentId}`) };
        return this.httpService.get('/api/batching/get-batch-info', options).toPromise();
    }

    public releaseDocumentBatch(documentId: number): Promise<void> {
        const options = { params: new HttpParams().set('documentId', `${documentId}`) };
        return this.httpService.get('/api/batching/release-batch', options).toPromise();
    }
}
